import React, { useState } from 'react';

function Onoff() {
    const [activeFaq, setActiveFaq] = useState({
        a: true,
        b: false,
        c: false,
        d: false,
        e: false,
        f: false,
        g: false
    });

    const toggleFaq = (faq) => {
        setActiveFaq(prevState => {
            const newState = {};
            Object.keys(prevState).forEach(key => {
                newState[key] = key === faq ? !prevState[key] : false;
            });
            return newState;
        });
    };

    return (
        <section className="row_am faq_section">
            <div className="container">
                <div className="faq_panel">
                    <div className="accordion" id="accordionExample">
                        <div className="card" data-aos="fade-up">
                            <div className="card-header" id="headingOne">
                                <h2 className="mb-0">
                                    <button type="button" className={`btn btn-link ${activeFaq.a ? "" : "collapsed"}`} onClick={() => toggleFaq('a')} data-toggle="collapse" data-target="#collapseOne">
                                        {activeFaq.a ? <i className="icon_faq icofont-minus"></i> : <i className="icon_faq icofont-plus"></i>}How can i pay ?
                                    </button>
                                </h2>
                            </div>
                            <div id="collapseOne" className={`collapse ${activeFaq.a ? "show" : ""}`} aria-labelledby="headingOne" data-parent="#accordionExample">
                                <div className="card-body">
                                    <p>Lorem Ipsum is simply dummy text of the printing and typesetting industry lorem Ipsum has. been the
                                        industrys standard dummy text ever since the when an unknown printer took a galley of type and
                                        scrambled it to make a type specimen book. It has survived not only five cen turies but also the
                                        leap into electronic typesetting, remaining essentially unchanged.</p>
                                </div>
                            </div>
                        </div>
                        <div className="card" data-aos="fade-up">
                            <div className="card-header" id="headingTwo">
                                <h2 className="mb-0">
                                    <button type="button" className={`btn btn-link ${activeFaq.b ? "" : "collapsed"}`} onClick={() => toggleFaq('b')} data-toggle="collapse" data-target="#collapseTwo">
                                        {activeFaq.b ? <i className="icon_faq icofont-minus"></i> : <i className="icon_faq icofont-plus"></i>}How to setup account ?
                                    </button>
                                </h2>
                            </div>
                            <div id="collapseTwo" className={`collapse ${activeFaq.b ? "show" : ""}`} aria-labelledby="headingTwo" data-parent="#accordionExample">
                                <div className="card-body">
                                    <p>Lorem Ipsum is simply dummy text of the printing and typesetting industry lorem Ipsum has. been the
                                        industrys standard dummy text ever since the when an unknown printer took a galley of type and
                                        scrambled it to make a type specimen book. It has survived not only five cen turies but also the
                                        leap into electronic typesetting, remaining essentially unchanged.</p>
                                </div>
                            </div>
                        </div>
                        <div className="card" data-aos="fade-up">
                            <div className="card-header" id="headingThree">
                                <h2 className="mb-0">
                                    <button type="button" className={`btn btn-link  ${activeFaq.c ? "" : "collapsed"}`} onClick={() => toggleFaq('c')} data-toggle="collapse" data-target="#collapseThree">
                                        {activeFaq.c ? <i className="icon_faq icofont-minus"></i> : <i className="icon_faq icofont-plus"></i>}What is process to get refund
                                        ?</button>
                                </h2>
                            </div>
                            <div id="collapseThree" className={`collapse ${activeFaq.c ? "show" : ""}`} aria-labelledby="headingThree" data-parent="#accordionExample">
                                <div className="card-body">
                                    <p>Lorem Ipsum is simply dummy text of the printing and typesetting industry lorem Ipsum has. been the
                                        industrys standard dummy text ever since the when an unknown printer took a galley of type and
                                        scrambled it to make a type specimen book. It has survived not only five cen turies but also the
                                        leap into electronic typesetting, remaining essentially unchanged.</p>
                                </div>
                            </div>
                        </div>
                        <div className="card" data-aos="fade-up" >
                            <div className="card-header" id="headingFour">
                                <h2 className="mb-0">
                                    <button type="button" className={`btn btn-link  ${activeFaq.d ? "" : "collapsed"}`} onClick={() => toggleFaq('d')} data-toggle="collapse" data-target="#collapseFour">
                                        {activeFaq.d ? <i className="icon_faq icofont-minus"></i> : <i className="icon_faq icofont-plus"></i>}What is process to get refund ?
                                    </button>
                                </h2>
                            </div>

                            <div id="collapseFour" className={`collapse ${activeFaq.d ? "show" : ""}`} aria-labelledby="headingFour" data-parent="#accordionExample">
                                <div className="card-body">
                                    <p>Lorem Ipsum is simply dummy text of the printing and typesetting industry lorem Ipsum has. been the
                                        industrys standard dummy text ever since the when an unknown printer took a galley of type and
                                        scrambled it to make a type specimen book. It has survived not only five cen turies but also the
                                        leap into electronic typesetting, remaining essentially unchanged.</p>
                                </div>
                            </div>
                        </div>
                        <div className="card" data-aos="fade-up" >
                            <div className="card-header" id="headingFive">
                                <h2 className="mb-0">
                                    <button type="button" className={`btn btn-link  ${activeFaq.e ? "" : "collapsed"}`} onClick={() => toggleFaq('e')} data-toggle="collapse"
                                        data-target="#collapseFive">{activeFaq.e ? <i className="icon_faq icofont-minus"></i> : <i className="icon_faq icofont-plus"></i>}Can i get code bug support for customization ?
                                    </button>
                                </h2>
                            </div>

                            <div id="collapseFive" className={`collapse ${activeFaq.e ? "show" : ""}`} aria-labelledby="headingFive" data-parent="#accordionExample">
                                <div className="card-body">
                                    <p>Lorem Ipsum is simply dummy text of the printing and typesetting industry lorem Ipsum has. been the
                                        industrys standard dummy text ever since the when an unknown printer took a galley of type and
                                        scrambled it to make a type specimen book. It has survived not only five cen turies but also the
                                        leap into electronic typesetting, remaining essentially unchanged.</p>
                                </div>
                            </div>
                        </div>
                        <div className="card" data-aos="fade-up" >
                            <div className="card-header" id="headingSix">
                                <h2 className="mb-0">
                                    <button type="button" className={`btn btn-link  ${activeFaq.f ? "" : "collapsed"}`} onClick={() => toggleFaq('f')} data-toggle="collapse"
                                        data-target="#collapseSix">{activeFaq.f ? <i className="icon_faq icofont-minus"></i> : <i className="icon_faq icofont-plus"></i>}Lorem Ipsum is simply dummy text of the printing and typesetting ?
                                    </button>
                                </h2>
                            </div>

                            <div id="collapseSix" className={`collapse ${activeFaq.f ? "show" : ""}`} aria-labelledby="headingSix" data-parent="#accordionExample">
                                <div className="card-body">
                                    <p>Lorem Ipsum is simply dummy text of the printing and typesetting industry lorem Ipsum has. been the
                                        industrys standard dummy text ever since the when an unknown printer took a galley of type and
                                        scrambled it to make a type specimen book. It has survived not only five cen turies but also the
                                        leap into electronic typesetting, remaining essentially unchanged.</p>
                                </div>
                            </div>
                        </div>
                        <div className="card" data-aos="fade-up" >
                            <div className="card-header" id="headingSeven">
                                <h2 className="mb-0">
                                    <button type="button" className={`btn btn-link  ${activeFaq.g ? "" : "collapsed"}`} onClick={() => toggleFaq('g')} data-toggle="collapse"
                                        data-target="#collapseSeven">{activeFaq.g ? <i className="icon_faq icofont-minus"></i> : <i className="icon_faq icofont-plus"></i>}Lorem Ipsum is simply dummy text of the printing and typesetting ?
                                    </button>
                                </h2>
                            </div>

                            <div id="collapseSeven" className={`collapse ${activeFaq.g ? "show" : ""}`} aria-labelledby="headingSeven" data-parent="#accordionExample">
                                <div className="card-body">
                                    <p>Lorem Ipsum is simply dummy text of the printing and typesetting industry lorem Ipsum has. been the
                                        industrys standard dummy text ever since the when an unknown printer took a galley of type and
                                        scrambled it to make a type specimen book. It has survived not only five cen turies but also the
                                        leap into electronic typesetting, remaining essentially unchanged.</p>
                                </div>
                            </div>
                        </div>

                    </div>
                </div>
            </div>
        </section>
    );
}

export default Onoff;
